export const CanAccessCheckResults = ["pt_admin", "customer_care", "superadmin", "useradmin", "uk_dfp_admin", "uk_shfy_admin"];
/*usertype that can access check results*/
